import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchCountriesQuery } from '@massilia/queries';
import { AutoComplete, useDebounce } from '@massilia/ui';
import { useStore } from '@tanstack/react-form';
import { MapPin } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useFieldContext } from '../hooks/use-app-form.js';
import { DEFAULT_OPTION } from '../schemas/estimate/base-schemas.js';
import { FieldDisplayValue } from './field-display-value.js';
import { FieldError } from './field-error.js';
export function CountryAutocompleteField({ autoFocus, emptyMessage = 'Aucun pays trouvé', label, onDisplayClick, placeholder = 'Pays de délivrance', renderType = 'edit', }) {
    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 200);
    const { data, isLoading } = useSearchCountriesQuery({
        search: debouncedSearchText,
    });
    const options = useMemo(() => {
        if (!data?.countries)
            return [];
        return data.countries.map((c) => ({
            label: c.frShortName,
            value: c.alpha3Code,
        }));
    }, [data]);
    const field = useFieldContext();
    const errors = useStore(field.store, (state) => state.meta.errors);
    const selectedOption = useMemo(() => {
        const currentValue = field.state.value?.value;
        if (!currentValue)
            return undefined;
        // First try to find in provided options
        const foundOption = options.find((opt) => opt.value === currentValue);
        if (foundOption)
            return foundOption;
        // Fallback to the provided option if it has a label (initial value case)
        if (field.state.value?.label) {
            return field.state.value;
        }
        return undefined;
    }, [options, field.state.value]);
    if (renderType === 'display') {
        return (_jsx(FieldDisplayValue, { label: label, onClick: onDisplayClick, value: field.state.value?.label ?? '' }));
    }
    return (_jsxs("div", { className: "relative flex flex-col gap-2", children: [label && _jsx("label", { className: "text-sm font-medium", children: label }), _jsx(AutoComplete, { autoFocus: autoFocus, emptyMessage: emptyMessage, icon: _jsx(MapPin, { className: "text-gray-light-700 h-4 w-4" }), isLoading: isLoading, onBlurCallBack: () => {
                    field.handleBlur();
                }, onInputChange: (text) => {
                    setSearchText(text);
                }, onValueChange: (opt) => {
                    if (opt) {
                        field.handleChange(opt);
                    }
                    else {
                        field.handleChange(DEFAULT_OPTION);
                    }
                }, options: options, placeholder: placeholder, shouldFilter: false, value: selectedOption }), _jsx(FieldError, { errors: errors })] }));
}
